import { Button, Typography } from "@material-ui/core";

export default function ToggleButton({ status, setStatus, disable }) {
  return (
    <Button
      variant="contained"
      size="small"
      onClick={() => setStatus(!status)}
      disabled={disable}
      style={{
        background: status === true ? "#1C8CF3" : "#7994C1",
        color: "white",
        minWidth: "20px",
      }}
    >
      <Typography variant="subtitle2">{status === true ? "On" : "Off"}</Typography>
    </Button>
  );
}
